import { watchAddresses } from "@softmax/web-features/leagues";
import { type GamePageContext } from "@/features/game/state";
import { createPlayApi } from "@/features/play/data";
import { theaterCorpus } from "@/features/watch/data";
export async function viewerHasLiveEntry({
  signal,
  slug,
  context,
}: {
  signal?: AbortSignal | undefined;
  slug: string;
  context?: GamePageContext | undefined;
}): Promise<boolean> {
  const [{ leagues }, seats] = await Promise.all([
    theaterCorpus({ signal, slug, context: context ?? null }),
    createPlayApi({ signal }).portfolio(),
  ]);

  if (!leagues || !seats)
    throw new Error("Your league membership is temporarily unavailable");

  const addresses = watchAddresses(leagues);
  const selectedLeagueId = context?.league?.id;
  const league = selectedLeagueId
    ? leagues.find((item) => item.id === selectedLeagueId)
    : addresses.leagueOf(slug);

  if (!league) return false;

  const ids = new Set(
    leagues
      .filter((item) => item.game.id === league.game.id)
      .map((item) => item.id),
  );
  return seats.some((seat) => ids.has(seat.league_id));
}
export async function viewerHasLiveEntryInLeague({
  signal,
  slug,
  context,
}: {
  signal?: AbortSignal | undefined;
  slug: string;
  context?: GamePageContext | undefined;
}): Promise<boolean> {
  const leagueId = context?.league?.id;
  const leagueRead = leagueId
    ? Promise.resolve(leagueId)
    : theaterCorpus({ signal, slug, context: context ?? null }).then(
        ({ leagues }) => {
          if (!leagues)
            throw new Error(
              "Your league membership is temporarily unavailable",
            );

          return watchAddresses(leagues).leagueOf(slug)?.id;
        },
      );
  const [id, seats] = await Promise.all([
    leagueRead,
    createPlayApi({ signal }).portfolio(),
  ]);

  if (!seats)
    throw new Error("Your league membership is temporarily unavailable");

  return Boolean(id && seats.some((seat) => seat.league_id === id));
}
